// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"UserDropdown_dropdown__36IeW","dropdown-menu":"UserDropdown_dropdown-menu__1ETvM","desktop":"UserDropdown_desktop__WkdY5","mobile":"UserDropdown_mobile__3HpVn"};